import { formatInTimeZone, toZonedTime } from 'date-fns-tz'
import { format } from 'date-fns'

export function formatInSiteZone(iso: string, timeZone: string | undefined, fmt: string): string {
  if (!timeZone) return format(new Date(iso), fmt)
  return formatInTimeZone(iso, timeZone, fmt)
}

export function siteZonedDate(iso: string, timeZone: string | undefined): Date {
  return timeZone ? toZonedTime(iso, timeZone) : new Date(iso)
}

export function tzAbbrev(timeZone: string | undefined, iso: string = new Date().toISOString()): string {
  if (!timeZone) return ''
  try {
    return new Intl.DateTimeFormat('en', { timeZone, timeZoneName: 'short' })
      .formatToParts(new Date(iso)).find(p => p.type === 'timeZoneName')?.value ?? ''
  } catch { return '' }
}

export function formatSiteTzLabel(timeZone: string | undefined): string {
  if (!timeZone) return ''
  const abbr = tzAbbrev(timeZone)
  return abbr ? `${timeZone} (${abbr})` : timeZone
}
